import type { ClientCartItem } from '@shared/gql/document-nodes'

export const areAllCartItemsReplaceable = (xs: ClientCartItem[]): boolean =>
  xs.every((cartItem) => cartItem.replace)
